import { createSlice } from '@reduxjs/toolkit';
import VwStkGirisDTO from 'src/models/StokEczane/GirisIslemleri/VwStkGirisDTO';
import VwStkGirisDetaySearchDTO from 'src/models/StokEczane/GirisDetay/VwStkGirisDetaySearchDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import VwStkGirisDetayDTO from 'src/models/StokEczane/GirisDetay/VwStkGirisDetayDTO';
import StokGirisDetayExcelCevap from 'src/models/StokEczane/GirisDetay/StokGirisDetayExcelCevap';

export class StokGirisUrunAramaKriterleri {
  aktifDurum?:string = "1";
  urunTipi?: number = 0;
  searchText?: string = "";
};

interface IStokGirisDetayState {
  isOpenDetay: boolean;
  stokGirisId: number;
  stokGirisDetayId: number;
  isOpenGirisSecDialog: boolean;
  stokGirisDetaySearchResult?: VwStkGirisDetaySearchDTO[];
  girisDetayList: Array<VwStkGirisDetayDTO>;
  excelSablonYukleListe: Array<StokGirisDetayExcelCevap>;
  refetch: boolean;
  urunAramaKriterleri: StokGirisUrunAramaKriterleri;
}

const StokGirisDetaySlice = createSlice<
  IStokGirisDetayState,
  MapReducerPayloads<
    IStokGirisDetayState,
    {
      setIsOpenDetay: boolean;
      setStokGirisId: number;
      setStokGirisDetayId: number;
      setIsOpenGirisSecDialog: boolean;
      setStokGirisDetaySearchResult: VwStkGirisDetaySearchDTO[];
      setGirisDetayList: Array<VwStkGirisDetayDTO>;
      setExcelSablonYukleListe: Array<StokGirisDetayExcelCevap>;
      setRefetch: boolean;
      setUrunAramaKriterleri: StokGirisUrunAramaKriterleri;
    }
  >
>({
  name: 'StokGirisDetay',
  initialState: {
    isOpenDetay: false,
    stokGirisId: null,
    stokGirisDetayId: null,
    isOpenGirisSecDialog: false,
    stokGirisDetaySearchResult: null,
    girisDetayList: new Array<VwStkGirisDetayDTO>(),
    excelSablonYukleListe: new Array<StokGirisDetayExcelCevap>(),
    refetch: false,
    urunAramaKriterleri: new StokGirisUrunAramaKriterleri(),
  },
  reducers: {
    setIsOpenDetay: (state, action) => {
      state.isOpenDetay = action.payload;
    },
    setStokGirisId: (state, action) => {
      state.stokGirisId = action.payload;
    },
    setStokGirisDetayId: (state, action) => {
      state.stokGirisDetayId = action.payload;
    },
    setIsOpenGirisSecDialog: (state, action) => {
      state.isOpenGirisSecDialog = action.payload;
    },
    setStokGirisDetaySearchResult: (state, action) => {
      state.stokGirisDetaySearchResult = action.payload;
    },
    setGirisDetayList: (state, action) => {
      state.girisDetayList = action.payload;
    },
    setExcelSablonYukleListe: (state, action) => {
      state.excelSablonYukleListe = action.payload;
    },
    setRefetch: (state, action) => {
      state.refetch = action.payload
    },
    setUrunAramaKriterleri: (state, action) => {
      state.urunAramaKriterleri = action.payload
    }
  }
});

export default StokGirisDetaySlice;
